import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { CryptoService } from '../../../services/crypto.service';

@Component({
  selector: 'app-vtuber-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.scss']
})
export class VTuberBankComponent implements OnInit {
  bankForm: any = {
    bank_name: '---',
    branch_code: '---',
    account_type: '---',
    account_number: '---',
    account_name: '---'
  }

  constructor(
    public auth: AuthService,
    private crypto: CryptoService
  ) {}

  ngOnInit() {
    if (this.auth.user.bank !== undefined) {
      this.bankForm = Object.assign({}, this.auth.user.bank)
      this.bankForm.account_name = this.crypto.decrypt(this.bankForm.account_name)
      this.bankForm.account_number = this.crypto.decrypt(this.bankForm.account_number)
      this.bankForm.account_type = this.crypto.decrypt(this.bankForm.account_type)
      this.bankForm.bank_name = this.crypto.decrypt(this.bankForm.bank_name)
      this.bankForm.branch_code = this.crypto.decrypt(this.bankForm.branch_code)
    }
  }

}
